import { css, jsx } from '@emotion/core';

import linkStyle from '@/src/shared/components/Link/style';
import { bp, colors, form as formStyle, space } from '@/styles';
import { accentGrayMedium } from '@/styles/utilities/colors';

const style = {
  link: css`
    font-weight: 700;
    color: ${colors.secondaryBlue};
  `,
  chartActions: css`
    @media ${bp.sm} {
      display: flex;
      margin-left: auto;
    }
  `,
  chartText: css`
    display: flex;
    align-items: baseline;
    &:hover {
      cursor: pointer;
      color: ${colors.primaryRed};
    }
  `,
  hasClear: css`
    .ant-form-item-label {
      width: 100%;
      label[for] {
        justify-content: space-between;
        align-items: baseline;
      }
    }
  `,
  publicationClear: css`
    margin-left: auto;
    display: flex;
    align-items: baseline;
    &:hover {
      cursor: pointer;
      color: ${colors.primaryRed};
    }
  `,
  actionText: css`
    color: ${colors.secondaryBlue};
    font-weight: bold;
  `,
  subsectionTitle: css`
    font: 700 2.8rem/3.6rem 'Lato', sans-serif;
    color: ${colors.secondaryGreyDark};
    margin-bottom: 1.6rem;
  `,
  rowWidth: css``,
  description: css`
    line-height: 1.75;
    font-size: 1.6rem;
    a {
      ${linkStyle.link}
    }
  `,
  radioGroup: css`
    font-size: 12px !important;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    line-height: 1.5;
    .ant-form label {
      font-size: 12px;
      font-weight: bold;
    }

    .ant-radio-wrapper {
      line-height: 38px;
      padding-bottom: 8px;
      font-size: 12px;
      @media ${bp.md} {
        padding-bottom: 0;
      }
    }

    .ant-radio-checked .ant-radio-inner {
      border-color: ${colors.secondaryBlue};
      &::after {
        background-color: ${colors.secondaryBlue};
      }
    }
    @media ${bp.md} {
      flex-direction: row;
      /* align-items: flex-end; */
      align-items: center;
    }
  `,
  radio: css`
    font-size: 2.4rem;
  `,
  formItemInline: css`
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    @media ${bp.md} {
      flex-direction: row;
      align-items: flex-start;
      /* align-items: center; */
    }
    .ant-form-item-label {
      padding-top: 5px;
      flex-shrink: 0;
    }
  `,
  whiteField: css`
    background-color: ${colors.white},
    border: 1px solid ${colors.accentGrayMedium};
  `,
};

export default style;
